export default "__VITE_ASSET__21784580__"